import { rangeHandler } from './range';
import { monthPickerHandler } from './month-picker';
import { convertStringToNumber } from './utils';

const AMOUNT_TYPE = 'AMOUNT_TYPE';
const TERM_TYPE = 'TERM_TYPE';

const onSetMonthlyRepayment = (
  value,
  calculator,
  type,
  interestRate,
  initiationFee,
  serviceFee,
  perThousandCharge
) => {
  const inputs = calculator.querySelectorAll('[data-input-field]');
  const inputAmount = inputs?.[0].querySelector('input');
  const inputTerm = inputs?.[1].querySelector('input');

  const monthlyRepayment = calculator.querySelector('[data-monthly-repayment]');

  type === AMOUNT_TYPE
    ? (inputAmount.value = new Intl.NumberFormat('en-US', {
      style: 'decimal',
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }).format(value))
    : (inputTerm.value = value);

  const loanAmount = convertStringToNumber(inputAmount.value) / 100;
  const period = convertStringToNumber(inputTerm.value);
  const percentage = interestRate / 100;

  const price =
  (loanAmount * (percentage / 12 * Math.pow(1 + percentage / 12, period))) / (Math.pow(1 + percentage / 12, period) - 1) +
  serviceFee +
  initiationFee / period +
  (loanAmount / 1000) * perThousandCharge;

  const formatedPrice = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  }).format(price);

  monthlyRepayment.textContent = `R ${formatedPrice}`;
  monthlyRepayment.setAttribute(
    'aria-label',
    `Estimated Monthly Repayment ${formatedPrice}`
  );
};

const onLoanCalculatorLoad = () => {
  const calculator = document.querySelector('[data-loan-calculator]');

  if (!calculator) return;

  const interestRate = parseFloat(
    calculator.getAttribute('data-interest-rate')
  );
  const initiationFee = parseFloat(
    calculator.getAttribute('data-initiation-fee')
  );
  const serviceFee = parseFloat(calculator.getAttribute('data-service-fee'));
  const perThousandCharge = parseFloat(
    calculator.getAttribute('data-per-thousand-charge')
  );

  const nextElement = calculator.querySelector('[data-monthly-repayment]');

  rangeHandler(calculator, (value) =>
    onSetMonthlyRepayment(
      value,
      calculator,
      AMOUNT_TYPE,
      interestRate,
      initiationFee,
      serviceFee,
      perThousandCharge
    )
  );
  monthPickerHandler(calculator, nextElement, (value) =>
    onSetMonthlyRepayment(
      value,
      calculator,
      TERM_TYPE,
      interestRate,
      initiationFee,
      serviceFee,
      perThousandCharge
    )
  );
};

export default onLoanCalculatorLoad;
